// Light scrim veil: the document behind stays faintly visible, matching the legacy loader.
// No token exists for a light scrim (the shared ones are dark overlays).
$veil-bg: rgb(255 255 255 / 86%); // TOKEN-GAP(uslegal): was #ffffff @ 86%

body.ul-popup-form-loader-open {
  overflow: hidden;
}

ul-popup-form-loader {
  .ul-popup-form-loader {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $veil-bg;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease, visibility 0.2s ease;
    z-index: -1;

    &--visible {
      opacity: 1;
      visibility: visible;
      z-index: 1001;

      .ul-popup-form-loader__spinner {
        animation-play-state: running;
      }
    }
  }

  .ul-popup-form-loader__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: map-get($spacings, md);
    padding: map-get($spacings, xl);
    text-align: center;
  }

  // Circular spinner: orange arc on a faint track.
  .ul-popup-form-loader__spinner {
    width: px-to-rem(56px);
    height: px-to-rem(56px);
    border: px-to-rem(4px) solid var(--background-color-brand-primary-lightest, rgb(255 144 0 / 20%));
    border-top-color: var(--action-color-brand-primary);
    border-radius: var(--radius-size-full, 50%);
    animation: ul-popup-form-loader-spin 0.8s linear infinite;
    animation-play-state: paused;
  }

  .ul-popup-form-loader__label {
    margin: 0;
    font-size: map-get($font-sizes, md);
    line-height: 1.5;
    font-weight: map-get($font-weights, medium);
    color: var(--text-color-primary);
  }
}

@keyframes ul-popup-form-loader-spin {
  to {
    transform: rotate(360deg);
  }
}
